// uio.no local.js

import xBase from "/vrtx/dist/resources/x1/js/x-base.js";
import xHeaderTools from "/vrtx/dist/resources/x1/js/x-header-tools.js";
import xAccordions from "/vrtx/dist/resources/x1/js/x-accordions.js";
import xConsentDialogHandler from "/vrtx/dist/resources/x1/js/x-consent-dialog-handler.js";
import xConsentSubtle from "/vrtx/dist/resources/x1/js/x-consent-subtle.js";
import xFilterFrontpageRows from "/vrtx/dist/resources/x1/js/x-filter-frontpage-rows.js";
import xGallery from "/vrtx/dist/resources/js/gallery.js";
import xMediaFullscreenCK5 from "/vrtx/dist/resources/x1/js/x-media-fullscreen-ck5.js";
import xMediaWide from "/vrtx/dist/resources/x1/js/x-media-wide.js";
import xResponsiveTable from "/vrtx/dist/resources/x1/js/x-responsive-table.js";
import xScrollColumnFeed from "/vrtx/dist/resources/x1/js/x-scroll-column-feed.js";
import xScrollMotion from "/vrtx/dist/resources/x1/js/x-scroll-motion.js";
import xTimeline from "/vrtx/dist/resources/x1/js/x-timeline.js";

// Imports from groups/all
import HeadLanguageSwitch from "/vrtx/dist/resources/js/head-language-switch.js";
import Dropdown from "/vrtx/dist/resources/js/dropdown.js";
import Toc from "/vrtx/dist/resources/js/toc.js";


// X-
xBase();
xHeaderTools();
xAccordions();
xConsentDialogHandler();
xConsentSubtle();
xFilterFrontpageRows();
xMediaFullscreenCK5();
xMediaWide.pageTopMedia();
xMediaWide.backgroundVideo();
xResponsiveTable();
xScrollColumnFeed();
xScrollMotion();
xTimeline();

// Groups/all
HeadLanguageSwitch.setup();
Dropdown.setup();
Toc.setup();


// xGallery
document.addEventListener("DOMContentLoaded", function(e) {
  document.querySelectorAll(".vrtx-image-gallery-include").forEach((g, i) => {
    const galleryId = g.id.replace(/[^0-9]/igm, "")
    const gallery = new xGallery();
    gallery.init(galleryId);
  });
});

// Sortable table dynamic import from groups/all if needed
if(document.querySelectorAll("table.sortable, table[class*=sortable-]").length) {
  import('/vrtx/dist/resources/js/tablesort.js')
  .then(obj => {
    window.Tablesort = obj.default;
    Tablesort.setup();
  })
  .catch(error => {
    console.error(error);
  });
}
